export const TOURISTS_TEXTS = {
  roomWord: 'номер',
  roomsForSuffix: 'для',
  adultsLabel: 'Взрослые',
  adultsHint: 'От 18 и старше',
  addChild: 'Добавить ребёнка',
  removeChild: 'Удалить ребёнка',
  childPrefix: 'Ребёнок: ',
  infantAge: 'до 1 года',
  addRoom: 'Добавить номер',
  removeRoom: 'Удалить номер',
  disclaimerPrefix: 'Можно бронировать ',
  disclaimerHighlight: 'только одинаковые номера',
  roomsCountLabel: 'Сколько номеров?',
  touristsLabel: 'Туристы',
} as const;
